// extracted by mini-css-extract-plugin
export default {"ArrowLink":"ArrowLink_ArrowLink__ikS7U"};